import processTireDotField from '@/features/products/functions/processTireDotField';
import { Tire } from '@/features/products/types/arktype/Tire';
import { TireDot } from '@/features/products/types/arktype/TireDot';
import { TireSize } from '@/features/products/types/arktype/TireSize';
import { Promotion } from '@/features/promotions/types/promotion';

export default function transformTireSize<
  T extends Pick<TireSize, 'id' | 'stock' | 'price' | 'specialPrice'> & {
    tire: Pick<Tire, 'id'>[];
    tireDot: Pick<TireDot, 'id' | 'yearOfManufacture' | 'stock'>[];
    itemPromotions?: Promotion[] | null;
  },
>(
  tireSize: T,
  tireDotEnabled: boolean = false
): Omit<T, 'tire'> & {
  tire: T['tire'][number];
} {
  return {
    ...tireSize,
    tire: tireSize.tire[0],
    tireDot: processTireDotField(tireSize, tireSize.tireDot, 'tireDots', tireDotEnabled).filter(
      (dot) => (tireDotEnabled ? dot.stock > 0 : true)
    ),
    itemPromotions: tireSize.itemPromotions ?? [],
    // specialPrice: [
    //   {
    //     id: tireSize.id,
    //     specialPrice: (tireSize.price ?? 0) - 50,
    //     minPurchaseQuantity: 3,
    //     validTo: dayjs().add(1, 'day').unix(),
    //     validFrom: dayjs().subtract(1, 'day').unix(),
    //   } satisfies SpecialPrice,
    // ]
  } satisfies T;
}
